import React from "react";
import Modal from "@/components/Modal";

// Confirmation dialog for destructive / real-money actions.
export default function ConfirmDialog({
  open, onClose, onConfirm, title, message,
  confirmText = "Confirm", cancelText = "Cancel",
  danger = false, loading = false, testId = "confirm-dialog",
}) {
  return (
    <Modal open={open} onClose={onClose} title={title} maxWidth="max-w-md" testId={testId}>
      <p className="text-sm text-[#cbd5e1] whitespace-pre-line leading-6 mb-6">{message}</p>
      <div className="flex gap-3">
        <button
          onClick={onClose}
          disabled={loading}
          className="flex-1 py-3 rounded-xl bg-[#334155] text-white font-semibold hover:bg-[#3f4d63] disabled:opacity-50"
          data-testid={`${testId}-cancel`}
        >
          {cancelText}
        </button>
        <button
          onClick={onConfirm}
          disabled={loading}
          className={`flex-1 py-3 rounded-xl font-bold text-white disabled:opacity-50 ${danger ? "bg-[#ef4444] hover:bg-[#dc2626]" : "bg-[#10b981] hover:bg-[#059669]"}`}
          data-testid={`${testId}-confirm`}
        >
          {loading ? "Working…" : confirmText}
        </button>
      </div>
    </Modal>
  );
}
